import { ChangeEvent } from 'react'

import { isObject } from './isObject'

export function isInputEvent(value: any): value is ChangeEvent {
  return value && isObject(value) && isObject(value.target)
}
